import React, { useState } from 'react';
import '../LoginPage/LoginPage.css';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';

const RegisterPage = () => {
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);
  const [showRepeat, setShowRepeat] = useState(false);
  const [focusedField, setFocusedField] = useState('');
  const [form, setForm] = useState({
    firstName: '',
    lastName: '',
    middleName: '',
    email: '',
    password: '',
    confirmPassword: '',
  });

  const [mismatched, setMismatched] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    if (e.target.name === 'confirmPassword') {
      setMismatched(form.password !== e.target.value);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (form.password !== form.confirmPassword) {
      setMismatched(true);
      return;
    }
    // Здесь можно отправить форму
    alert('Успешная регистрация!');
    navigate('/directory');
  };

  const createRipple = (event) => {
    const button = event.currentTarget;
    const circle = document.createElement("span");
    const diameter = Math.max(button.clientWidth, button.clientHeight);
    const radius = diameter / 2;

    circle.style.width = circle.style.height = `${diameter}px`;
    circle.style.left = `${event.clientX - button.getBoundingClientRect().left - radius}px`;
    circle.style.top = `${event.clientY - button.getBoundingClientRect().top - radius}px`;
    circle.classList.add("ripple");

    const existingRipple = button.getElementsByClassName("ripple")[0];
    if (existingRipple) existingRipple.remove();
    button.appendChild(circle);
  };

  return (
    <div className="login-wrapper">
      <form className="login-box" onSubmit={handleSubmit}>
        <h2>Регистрация</h2>

        {['lastName', 'firstName', 'middleName', 'email'].map((field) => (
          <div
            key={field}
            className={`input-block ${focusedField === field || form[field] ? 'focused' : ''}`}
          >
            <input
              type="text"
              name={field}
              required
              value={form[field]}
              onChange={handleChange}
              onFocus={() => setFocusedField(field)}
              onBlur={() => setFocusedField('')}
            />
            <label>
              {{
                lastName: 'Фамилия',
                firstName: 'Имя',
                middleName: 'Отчество',
                email: 'Почта',
              }[field]}
            </label>
          </div>
        ))}

        <div className={`input-block ${focusedField === 'password' || form.password ? 'focused' : ''}`}>
          <input
            type={showPassword ? 'text' : 'password'}
            name="password"
            required
            value={form.password}
            onChange={handleChange}
            onFocus={() => setFocusedField('password')}
            onBlur={() => setFocusedField('')}
          />
          <label>Пароль</label>
          <span className="password-toggle" onClick={() => setShowPassword(!showPassword)}>
            {showPassword ? <FaEyeSlash /> : <FaEye />}
          </span>
        </div>

        <div className={`input-block ${focusedField === 'confirmPassword' || form.confirmPassword ? 'focused' : ''}`}>
          <input
            type={showRepeat ? 'text' : 'password'}
            name="confirmPassword"
            required
            value={form.confirmPassword}
            onChange={handleChange}
            onFocus={() => setFocusedField('confirmPassword')}
            onBlur={() => setFocusedField('')}
          />
          <label>Повторите пароль</label>
          <span className="password-toggle" onClick={() => setShowRepeat(!showRepeat)}>
            {showRepeat ? <FaEyeSlash /> : <FaEye />}
          </span>
        </div>

        {mismatched && (
          <div className="error-message">Пароли не совпадают</div>
        )}

        <button
          type="submit"
          className="login-button"
          onMouseDown={createRipple}
        >
          Зарегистрироваться
        </button>

        <Link to="/login" className="login-subtext">
          Уже есть аккаунт?
        </Link>
      </form>
    </div>
  );
};

export default RegisterPage;
